export default "__VITE_ASSET__EqngEFZC__"